import { render, staticRenderFns } from "./ColumnsPreferencesConfigModal.vue?vue&type=template&id=180d9065&"
import script from "./ColumnsPreferencesConfigModal.vue?vue&type=script&lang=js&"
export * from "./ColumnsPreferencesConfigModal.vue?vue&type=script&lang=js&"
import style0 from "./ColumnsPreferencesConfigModal.vue?vue&type=style&index=0&id=180d9065&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports